import React from "react";
import { StyleSheet } from "react-native";
import Animated, {
  useAnimatedRef,
  useAnimatedStyle,
  useScrollViewOffset,
} from "react-native-reanimated";
import { View } from "~/components/V2/View";
import { useResponsive } from "~/hooks/useResponsive";
import { styleConstantsV2 } from "~/style/styleConstantsV2";

const S = StyleSheet.create({
  card: {
    // flex: 1,
    backgroundColor: styleConstantsV2.colorWhite,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,

    paddingVertical: 48,
  },
});

function linearmap(
  x: number, // 0 - ~1000
  in_min: number, // 0
  in_max: number, // 150
  out_min: number, // -25
  out_max: number, // -145
) {
  const result =
    ((x - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;

  // clamp the result on out_max end
  if (result < out_max) {
    return out_max;
  }

  return result;
}

export const HomeScreenContainer = ({
  topBarContent = null,
  mainContent = null,
}: {
  topBarContent?: React.ReactNode | null;
  mainContent?: React.ReactNode | null;
}) => {
  const r = useResponsive();
  const animatedRef = useAnimatedRef<Animated.ScrollView>();
  const scrollOffset = useScrollViewOffset(animatedRef);

  const animatedStyle = useAnimatedStyle(() => {
    const animatedMarginTop = linearmap(scrollOffset.value, 0, 200, -25, -145);

    return {
      ...S.card,
      paddingHorizontal: r(18, 18, 88),
      marginTop: r(animatedMarginTop, -25, -25),
    };
  });

  return (
    <>
      <View
        colorPrimary
        style={{
          paddingHorizontal: r(33, 33, 88),
          paddingTop: r(28, 28, 40),
          paddingBottom: r(50, 50, 60),
          minHeight: 144,
        }}
      >
        {topBarContent}
      </View>

      <Animated.ScrollView ref={animatedRef} style={animatedStyle}>
        {mainContent}
      </Animated.ScrollView>
    </>
  );
};
